import React, { useEffect, useState } from "react";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import MDButton from "components/MDButton";
import { Button, Divider } from "@mui/material";
import MDTypography from "components/MDTypography";

import { Delete } from "@mui/icons-material";
import { API_URL } from "config";
import { useAuthContext } from "hooks/useAuthContext";
import { useProjectContext } from "hooks/useProjectContext";
import { toast } from "sonner";

// import { useDeleteAcademicYear } from "hooks/settingsHooks/useDeleteAcademicYear";

const DeleteHomePageProjectPopup = ({
  homepageproject,
  fetchHomepageProjects,
}) => {
  const [open, setOpen] = useState(false);
  const { user } = useAuthContext();
  const { dispatch } = useProjectContext();
  const [error, setError] = useState(null);
  const [success, setSuccess] = useState(null);

  // Remove project from homepage
  const handleRemoveFromHomepage = async () => {
    try {
      const response = await fetch(
        `${API_URL}/projects/removefromhomepage/${homepageproject.id}`,
        {
          method: "PATCH",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${user.token}`,
          },
          body: JSON.stringify({ is_chosen: false }),
        }
      );

      if (response.ok) {
        // Fetch homepage projects
        fetchHomepageProjects();
        // Remove project from homepage
        dispatch({ type: "REMOVE_FROM_HOMEPAGE", payload: homepageproject.id });
      }
    } catch (error) {
      setError(error);
    } finally {
      dispatch({ type: "REMOVE_FROM_HOMEPAGE", payload: homepageproject.id });
      setSuccess(true);
      setOpen(false);
      fetchHomepageProjects();
    }
  };

  useEffect(() => {
    if (error) {
      toast.error("Error", {
        description: "Error removing project from homepage",
      });
    }
    if (success) {
      toast.success("Success", {
        description: "Project removed from homepage successfully",
      });
    }
    setError(null);
    setSuccess(null);
  }, [error, success]);

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
    // Clear error on close
    setError(null);
    setSuccess(null);
  };

  return (
    <div>
      <Button onClick={handleClickOpen}>
        <Delete sx={{ cursor: "pointer", fontWeight: "bold" }} color="error" />
      </Button>
      <Dialog
        open={open}
        onClose={handleClose}
        maxWidth="md"
        fullWidth
        PaperProps={{
          style: { padding: 5, borderRadius: 10 },
        }}
      >
        <DialogTitle display="flex" justifyContent="center">
          Confirm Action
        </DialogTitle>
        <Divider sx={{ my: 0 }} />
        <DialogContent>
          <MDTypography
            display="flex"
            flexDirection="row"
            justifyContent="center"
            textAlign="center"
          >
            Are you sure you want to remove
            <strong style={{ margin: "0 4px" }}>
              {homepageproject.projectTitle || "this project"}
            </strong>
            from the homepage?
          </MDTypography>
        </DialogContent>
        <DialogActions>
          <MDButton onClick={handleClose} color="secondary" variant="contained">
            No
          </MDButton>
          <MDButton
            onClick={handleRemoveFromHomepage}
            color="error"
            variant="contained"
          >
            Yes
          </MDButton>
        </DialogActions>
      </Dialog>
    </div>
  );
};

export default DeleteHomePageProjectPopup;
